module.exports = __webpack_public_path__ + "img/image5-1.4e562b4a.png";